import React from "react";
import ReactTable from "react-table";
import CumulativeColumn from "./CumulativeColumn";
import CumulativeData from "./CumulativeData";

const CumulativeTable = () => {
    const cumul = CumulativeData();

    return (
        <ReactTable
            data={ cumul }
            columns={ CumulativeColumn() }
            defaultPageSize={ 3 }
            minRows={ 1 }
            sortable = { false }
            showPagination={ false }
            className="-striped -highlight"
        />
    );
};

export default CumulativeTable;


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/Cumulative/CumulativeTable.js